export default __webpack_public_path__ + "static/media/Background 5_00077.154d5935.png";